import { performRequest } from "../performRequest"



export const syncDataApi = (params) => {
    return performRequest("get", "api/ess/sync-data/",params)
}

